import { computed } from 'vue';
import { useLeadAanvraagStore } from '@/stores/lead-aanvraag/lead-aanvraag';
import SubflowStatusEnum from '@/stores/lead-aanvraag/SubflowStatus.enum.js';
import { useAanbodDefinitieByVersionQuery } from '@/use/aanbod-definitie/use-aanbod-definitie-by-version-query';
import { useRouteExtensions } from '@/use/use-route-extensions';
export const useFlowExtensions = () => {
  const { lang } = useRouteExtensions();
  const leadAanvraagStore = useLeadAanvraagStore();

  const aanbodVersieId = computed(() => {
    return leadAanvraagStore.leadAanvraag?.aanbodVersieId;
  });

  const subflowVersieIds = computed(() => leadAanvraagStore.subflowVersieIds);

  const { data: aanbodDefinitie } = useAanbodDefinitieByVersionQuery(
    aanbodVersieId,
    subflowVersieIds,
    lang
  );

  const totaalPrijs = computed(() => {
    return finishedSubflows.value
      ?.map((finishedSubflow) => finishedSubflow.state.prijsBruto ?? 0)
      .reduce((a, b) => a + b, 0);
  });

  const finishedSubflows = computed(() => {
    const { leadAanvraag } = useLeadAanvraagStore();
    return leadAanvraag?.subflowState
      ?.filter((state) => state.subflowStatus === SubflowStatusEnum.Finished)
      ?.map((finishedSubflowState) => ({
        state: finishedSubflowState,
        definitie: aanbodDefinitie?.value?.subflows.find(
          (subflow) => subflow.naam === finishedSubflowState.subflowNaam
        )
      }));
  });

  return {
    totaalPrijs,
    finishedSubflows
  };
};
